import { useState } from 'react'
import Modal from 'react-modal'
import store from 'store2'

const CustomPopup = ({ message }) => {
  const [isOpen, setOpen] = useState(true)
  const shopId = window.shop && window.shop.id
  const hiddenShopPopups = store.session.get('hideShopPopup') || [] // array of shop ids

  const handleClose = () => {
    setOpen(false)
    try {
      hiddenShopPopups.push(shopId)
      store.session('hideShopPopup', hiddenShopPopups)
    } catch (e) {
      console.error(e)
    }
  }

  if(hiddenShopPopups.includes(shopId)) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      ariaHideApp={false}
      className='Modal react-popup custom-popup'
      overlayClassName='Overlay'
    >
      <span className='close-btn' onClick={handleClose} />
      <p
        className='custom-popup__text'
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </Modal>
  )
}

export default CustomPopup
